module.exports = __webpack_public_path__ + "img/DEXTER.d78dbd37.svg";